import { render, staticRenderFns } from "./recordDetails.vue?vue&type=template&id=303d81bd&scoped=true&"
import script from "./recordDetails.vue?vue&type=script&lang=js&"
export * from "./recordDetails.vue?vue&type=script&lang=js&"
import style0 from "./recordDetails.vue?vue&type=style&index=0&id=303d81bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303d81bd",
  null
  
)

export default component.exports